import * as React from 'react';

import { Button, InlineNotification, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/admin-shared';

interface Props {
  message: React.ReactNode;
}

/**
 * Used to display an error that cannot be recovered from except by reloading the page
 */
const CatastrophicErrorNotification = ({ message }: Props) => {
  return (
    <InlineNotification
      primaryAction={
        <Button variant="ghost" onClick={() => window.location.reload()}>
          {_t('Refresh')}
        </Button>
      }
      severity="error"
      title={_t('An error has occurred')}
    >
      <Typography2 component="p">{message}</Typography2>
    </InlineNotification>
  );
};

export default CatastrophicErrorNotification;
